/* eslint-disable @typescript-eslint/camelcase */
export const emojiObj = {
  emoji_1: '😀',
  emoji_2: '😁',
  emoji_3: '😂',
  emoji_4: '😃',
  emoji_5: '😄',
  emoji_6: '😅',
  emoji_7: '😆',
  emoji_8: '😱',
  emoji_9: '😳',
  emoji_10: '😵',
  emoji_11: '😡',
  emoji_12: '😠',
  up: '👍',
  down: '👎',
  heart: '❤️ ',
  cold_sweat: '😰',
  emoji_13: '🙌',
  emoji_14: '🙏'
};
